import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {erstatt} from "../../stoettefunk/lister";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('MøtedeltakerRessurs');

export class MøtedeltakerRessurs extends BasisRessurs<l.MøteModell> {

    static regNavn = "møtedeltakereRessurs";

    static forInjisering() {
        return [
            "$resource",
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            MøtedeltakerRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService, ressursFeilhåndtering: RessursFeilhåndtering, gettextCatalog: gettextCatalog) {
        super("moete",
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                avslåInnkalling: {method: 'POST', url: "/api/moetedeltaker/:id/avslaaInnkalling", params: {id: '@id'}},
                aksepterInnkalling: {
                    method: 'POST',
                    url: "/api/moetedeltaker/:id/aksepterInnkalling",
                    params: {id: '@id'}
                }
            });
    }

    //offentlige metoder

    avslåInnkalling(møteId: string): l.MøtedeltakerModell {
        debug("avslåInnkalling", møteId);
        return this.ressurs['avslåInnkalling'](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil ved avslag på møteinnkalling"))
        );
    }

    aksepterInnkalling(møteId: string): l.MøtedeltakerModell {
        debug("aksepterInnkalling", møteId);
        return this.ressurs['aksepterInnkalling'](
            {id: møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil ved godkjenning av møteinnkalling"))
        );
    }

    /** Oppdaterer deltaker i angitt møte.deltakere med verdier angitt i oppdatertDeltaker */
    static oppdaterMøtedeltaker(møte: l.MøteModell, oppdatertDeltaker: l.MøtedeltakerModell) {
        erstatt(møte.deltakere, oppdatertDeltaker, d => d.id === oppdatertDeltaker.id);
    }
}
